// Cart
function openCart(){
  document.querySelector('.cart-overlay').style.display='block';
  document.querySelector('.cart-panel').classList.add('open');
  fetchCart();
}
function closeCart(){
  document.querySelector('.cart-overlay').style.display='none';
  document.querySelector('.cart-panel').classList.remove('open');
}
function fetchCart(){
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    const el=document.getElementById('cart-items');
    const badge=document.getElementById('cart-badge');
    const total=document.getElementById('cart-total');
    if(!cart.items.length){
      el.innerHTML='<p class="cart-empty">カートは空です</p>';
      total.textContent='¥0';
      badge.classList.remove('show');
      return;
    }
    const count=cart.items.reduce((s,i)=>s+i.quantity,0);
    badge.textContent=count; badge.classList.toggle('show',count>0);
    total.textContent='¥'+cart.total_price/100;
    el.innerHTML=cart.items.map(item=>`
      <div class="cart-item">
        ${item.image?`<img src="${item.image}" alt="${item.product_title}">`:''}
        <div class="cart-item-info">
          <p class="cart-item-name">${item.product_title}</p>
          <p class="cart-item-price">${item.variant_title||''}</p>
          <div class="cart-qty">
            <button onclick="changeQty('${item.key}',-1)">−</button>
            <span>${item.quantity}</span>
            <button onclick="changeQty('${item.key}',1)">＋</button>
          </div>
        </div>
        <p class="cart-item-price">¥${(item.final_line_price/100).toLocaleString()}</p>
        <button class="cart-remove" onclick="changeQty('${item.key}',-999)">×</button>
      </div>`).join('');
  });
}
function changeQty(key,delta){
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    const item=cart.items.find(i=>i.key===key);
    if(!item)return;
    const newQty=Math.max(0,item.quantity+delta);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:newQty})})
      .then(()=>fetchCart());
  });
}
function checkout(){window.location.href='/checkout';}
function buyNow(variantId){
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(variantId),quantity:1})})
    .then(()=>{window.location.href='/checkout';});
}
function updateVariantPrice(sel){
  const opt=sel.options[sel.selectedIndex];
  const el=document.getElementById('pp-price');
  if(el&&opt.dataset.price) el.textContent=opt.dataset.price;
  document.querySelectorAll('.pp-select-hidden').forEach(s=>s.value=sel.value);
}
